import { INoRowsOverlayComp } from 'ag-grid-community';

export class CustomNoRowsOverlay implements INoRowsOverlayComp {
    private gui: HTMLElement;

    constructor() {}

    init(params) {
        this.gui = document.createElement('div');
        this.gui.innerHTML = `
        <div class="ag-overlay-loading-center">   
            <span> ${params.noRowsMessage} </span>
        </div>
    `;
    }

    getGui(): HTMLElement {
        return this.gui;
    }
}